const same = (a, b) => JSON.stringify(a) === JSON.stringify(b);

// PATCH body for Hours & Setup: only what the user changed since `base` was loaded, with changed
// days merged onto `latest` (the server copy fetched just before saving) so stale pages never revert others' saves.
export function buildHoursSaveBody(base, mine, latest) {
    const body = {};
    for (const key of Object.keys(mine)) {
        if (key !== "business_hours" && !same(base[key], mine[key])) body[key] = mine[key];
    }
    const changedDays = Object.keys(mine.business_hours).filter(
        (day) => !same(base.business_hours[day], mine.business_hours[day]),
    );
    if (changedDays.length > 0) {
        body.business_hours = { ...latest.business_hours };
        for (const day of changedDays) body.business_hours[day] = mine.business_hours[day];
    }
    return body;
}
